import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
  Autocomplete,
  ListItemText,
  Paper,
  IconButton,
  CircularProgress,
  MenuItem,
  TextField,
  Backdrop,
  Popover,
  Tooltip,
  Skeleton,
  Stack,
  Button,
  Fade,
  Checkbox,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import MUILink from '@mui/material/Link';
import { useLocation } from 'react-router-dom';
import { visuallyHidden } from '@mui/utils';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { Clear, LocalPrintshop, Share, MarkEmailUnread, EditOff, ArrowCircleRight } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import EditIcon from '@mui/icons-material/Edit';
import { Link, useNavigate } from 'react-router-dom';
import { MoreVert } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { display } from '../../redux/reducers/sidebar';
import { MoneyFormatv3 } from '../../library/MoneyFormat';
import { API, graphqlOperation } from 'aws-amplify';
import MuiAlert from '@mui/material/Alert';
import DeleteCrDrNoteMaster from '../../components/modals/DeleteCrDrNoteMaster';
import DeleteSelectedCrDrNoteMaster from '../../components/modals/DeleteSelectedCrDrNoteMaster';
import { ThreeDot } from '../../components/DropDown/ThreeDot';
import DropDownForListing from '../../components/DropDown/DropDown';
import { useWarningModal } from '../../components/modals/AddUnits';
import { showErrorSnackbar, showWarningSnackbar } from '../../components/snackBar/snakbar';
import { CloudDownload, CloudUpload } from '@mui/icons-material';
import LinkList from '../../components/Buttons/linkList';
import { updateTitle, updateViewTitle } from '../../redux/reducers/titleSlice';
import { createDebouncedCallback } from '../../hooks/createDebouncedCallback';
import dayjs from 'dayjs';
import { DateRangeRsuite, MoneyTextFieldRange, SimplePeriodDropdown } from '../../components';
import PeriodDropDown from '../../components/DropDown/PeriodDropDown';
import {
  checkandopenpdf,
  defaultRowsPerPage,
  defaultRowsPerPageOptions,
  fetchAndPrintPDF,
  getDefaultSorting,
  handleFreeze,
} from '../../utils/common';
import MoneyRanger from '../../components/formElements/MoneyRanger';
import { ShareModal } from '../../components/modals/Share';
import { getTransactionMaster, listCrDrNoteMasterv2, listCrDrNoteMasterCount } from '../../graphql';
import { TableCell } from '../../components/Table/TableCell';
import { LedgerTransactionModalv2 } from '../LedgerTransaction';
import { formatUnixTimestamp } from '../../library/dayJs';
import pdfImage from '../../assets/images/attachments/pdf.png';
import { useThemes } from '../../components/Theme/theme';
import TableSearchButton from '../PrimeFigma/Components/TableSearchButton';
import RollingSoon from '../../components/Ui/RollingSoon';
import { SendEmailModalWrapper, useSendEmailModal } from '../../features/Email';
import { useMediaQuery } from 'rsuite/esm/useMediaQuery/useMediaQuery';
import { useFetchOpeningBalanceDateQuery } from '../../redux/apis/openingbalacedate.api';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCell = [
  {
    id: 'CrDrNoteDate',
    numeric: false,
    disablePadding: true,
    label: 'Debit Note Date',
    width: '100px',
  },
  {
    id: 'CrDrNoteNumber',
    numeric: false,
    disablePadding: false,
    label: 'Debit Note No#',
    width: '150px',
  },
  // {
  //   id: "PartyInvoiceDate",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Party Invoice Date",
  //   width: "150px",
  // },
  {
    id: 'PartyInvoiceNumber',
    numeric: false,
    disablePadding: false,
    label: 'Party Invoice#',
    width: '130px',
  },
  {
    id: 'partyname',
    numeric: false,
    disablePadding: false,
    label: 'Party Name',
    width: '130px',
  },
  {
    id: 'Status',
    numeric: false,
    disablePadding: false,
    label: 'Status',
    width: '100px',
    disableSort: true,
  },
  {
    id: 'dueDateTimeStamp',
    numeric: false,
    disablePadding: false,
    label: 'DueDate',
    width: '100px',
  },
  {
    id: 'GrandTotalAmount',
    numeric: true,
    disablePadding: false,
    label: 'Amount (₹)',
    width: '100px',
  },
  // {
  //   id: "BalanceDueAmount",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Balance Due (₹)",
  //   width: "80px",
  // },
  {
    id: 'overDueDays',
    numeric: true,
    disablePadding: false,
    label: 'Due in/Over Due',
    width: '130px',
  },
  {
    id: 'Action',
    numeric: false,
    disablePadding: false,
    label: 'Actions',
    width: '100px',
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    onDelete,
    setEnableSearch,
    EnableSearch,
    rowLength,
    setShowAction,
    showAction,
    scroll,
  } = props;
  const { theme } = useThemes();

  function overDueFunction(label) {
    const [beforeSlash, afterSlash] = label.split('/');

    return (
      <span>
        <span style={{ color: 'green' }}>{beforeSlash}/</span>
        <span style={{ color: 'red' }}>{afterSlash}</span>
      </span>
    );
  }
  const smalldevices = useMediaQuery('(max-width:480px)');
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow
        sx={{
          '.MuiTableCell-root': {
            backgroundColor: `${theme.palette.background.tablebg} !important`,
            fontSize: '14px',
          },
          backgroundColor: 'background.tablebg',
          '.MuiTableCell-head': {
            backgroundColor: 'background.tablebg',
            padding: '2px 10px',
            borderBottom: '0px',
          },
          height: '35px',
        }}
      >
        <TableCell
          sx={{
            minWidth: '50px',
            padding: '2px 10px',
          }}
        >
          <Checkbox
            sx={{ color: 'input.border' }}
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all debit notes',
            }}
            size="small"
          />
        </TableCell>
        {headCell.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              minWidth: headCell.width,
              position: headCell.id === 'Action' ? 'sticky' : '',
              right: headCell.id === 'Action' ? 0 : '',
              // borderLeft: headCell.id === "Action" ? "1px solid" : "0px",
              whiteSpace: 'nowrap',
            }}
            //  sx={{maxWidth:headCell.width}}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: headCell.id === 'Action' ? 'center' : 'space-between',
                alignItems: 'center',
                flexDirection: headCell.numeric ? 'row-reverse' : '',
                // border: headCell.id === 'Action' ? '1px solid black' : '',
                borderRadius: headCell.id === 'Action' ? '3px' : '',
                width: '100%',
                backgroundColor: headCell.id === 'Action' ? 'white' : 'background.tablebg',
                boxShadow: headCell.id === 'Action' && scroll ? '0px 4px 8px rgba(0, 0, 0, 0.6)' : '',
                '&:active': {
                  transform: scroll ? 'scale(0.92)' : 'scale(1)',
                },
              }}
              id={headCell.id === 'Action' ? 'action' : ''}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (headCell.label === 'Actions') {
                  setShowAction((pre) => !pre);
                }
              }}
            >
              <>
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={headCell.id == 'Action' || headCell.disableSort ? null : createSortHandler(headCell.id)}
                  hideSortIcon={headCell.id === 'Action' || headCell.disableSort}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{}}>{headCell.id === 'overDueDays' ? overDueFunction(headCell.label) : headCell.label}</Box>
                    {orderBy === headCell.id ? (
                      <Box component="span" sx={visuallyHidden}>
                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                      </Box>
                    ) : null}
                    {headCell.id === 'Action' && scroll ? (
                      <ArrowCircleRight
                        sx={{
                          transition: 'transform 0.3s ease-in-out',
                          marginLeft: '10px',
                          transform: !showAction ? 'rotate(180deg)' : 'rotate(0deg)',
                          olor: !showAction ? 'gray' : '#ee5b2b',
                        }}
                        fontSize="small"
                      />
                    ) : null}
                    {/* {headCell.id !== "Action" ? (
                      <SearchIcon
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setEnableSearch((prev) => !prev);
                        }}
                        sx={{ marginLeft: "10px" }}
                        fontSize="small"
                      />
                    ) : null} */}
                  </Box>
                </TableSortLabel>
              </>
            </Box>
          </TableCell>
        ))}
        {numSelected > 0 ? (
          <TableCell>
            <ThreeDot
              onDelete={() => {
                onDelete(true);
              }}
            />
          </TableCell>
        ) : null}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function AllDebitNote() {
  const { theme } = useThemes();

  const dispatch = useDispatch();
  dispatch(display());
  const location = useLocation();

  const navigate = useNavigate();
  const { defaultSortingColumn, defaultSortingOrder } = getDefaultSorting('crdrnote');
  const [order, setOrder] = useState(defaultSortingOrder);
  const [orderBy, setOrderBy] = useState(defaultSortingColumn);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  // Store latest values in refs to avoid stale closures
  const rowsPerPageRef = useRef(rowsPerPage);
  rowsPerPageRef.current = rowsPerPage;

  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [rows, setRows] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [circularOpen, setCircularOpen] = useState(true);
  const [filteredList, setFilteredList] = useState([]);
  const [itemData, setItemData] = useState({});
  const [deleteSelectedModal, setDeleteSelectedModal] = useState(false);
  const [partyDetails, setPartyDetails] = useState([]);
  const [ListSelection, setListSelection] = useState('All');
  const [dataCount, setdataCount] = useState(0);
  const defaultFilterColumns = {
    CrdrNoteDate: '',
    CrDrNoteNumber: '',
    PartyInvoiceDate: '',
    PartyInvoiceNumber: '',
    PartyName: '',
    Status: '',
    DueDate: '',
    Amount: '',
    AmountFrom: '',
    AmountTo: '',
    BalanceDueAmount: '',
    overDueDays: '',
    CrdrNoteDateFrom: '',
    CrdrNoteDateTo: '',
    CancelFlag: '',
    GrandTotalAmount: '',
    DueDateTo: '',
    DueDateFrom: '',
  };
  const [filterColumns, setFilterColumns] = useState(defaultFilterColumns);
  const handleResetFilterColumns = (status) => (status === false ? setFilterColumns(defaultFilterColumns) : null);
  const filterColumnsRef = useRef(filterColumns);
  filterColumnsRef.current = filterColumns;
  const debouncedSearchRef = useRef(null);
  const [exportStartDate, setExportStartDate] = useState('');
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [anchorEl, setAnchorEl] = useState(null);
  // Click handler for the main box to open the popover
  const handleClickBox = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  // Click handler to close the popover
  const handleClose = () => {
    setAnchorEl(null);
  };
  const { data: openingBalanceDate, isLoading } = useFetchOpeningBalanceDateQuery(
    {
      invoicetypecd: 'Sales',
      invoiceid: 0,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  // Click handler to close the popover
  const obDate = dayjs(openingBalanceDate?.getMinMaxInvoiceDate?.openingbalancedate).unix();
  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  useEffect(() => {
    if (startDate > obDate) {
      setExportStartDate(startDate);
    } else {
      setExportStartDate(obDate);
    }
  }, [obDate, startDate]);
  // Check if the popover should be open based on anchorEl
  const open = Boolean(anchorEl);

  // Options to display in the popover, each with a label and onClick handler
  const options = [
    // {
    //   label: 'Import',
    //   icon: <CloudDownload sx={{ color: 'blue' }} />,
    //   onClick: () => {},
    //   link: '/import-data',
    // },
    // {
    //   label: 'Export',
    //   icon: <CloudUpload sx={{ color: '#ffa500' }} />,
    //   onClick: () => {
    //     if (rows.length > 0) {
    //       setExportModalOpen(true);
    //       setExportItem('Debit Note');
    //     } else {
    //       // setWarningSnakbar(true);
    //       // setWarningMsg("No data available for export.");
    //       showWarningSnackbar('No data available for export.');
    //     }
    //   },
    //   link: '',
    //   rollingOutSoon: true
    // },
    {
      label: 'Export',
      icon: <CloudUpload sx={{ color: '#ffa500' }} />,
      onClick: () => {
        // if (invoiceRows.length > 0) {
        //   setExportModalOpen(true);
        //   setExportItem('INVOICE');
        // } else {
        //   showWarningSnackbar('No data available for export.');
        // }
        // const to = `/exports/sales?startDate=${startDate}&endDate=${endDate}`
        // navigate('/');
      },
      link: `/exports/debit?startDate=${exportStartDate}&endDate=${endDate}`,
      rollingOutSoon: true,
    },
    {
      label: 'Send Selected Debit Notes',
      icon: <MarkEmailUnread />,
      onClick: () => {
        handleBulkEmail();
      },
      link: '',
    },
  ];
  const handleRequestSort = (event, property) => {
    let isAsc = orderBy === property && order === 'asc';
    if (property === 'dueDate') {
      isAsc = order === 'asc' ? true : false;
      setOrderBy('dueDateTimeStamp');
    } else {
      setOrderBy(property);
    }
    setOrder(isAsc ? 'desc' : 'asc');
  };

  const handleBulkEmail = () => {
    if (Freeze === 1) {
      return handleFreeze();
    }
    if (emailSendingSelection.length > 0) {
      openModal(
        'debitnote',
        emailSendingSelection.map((note) => ({
          id: Number(note.crdrnoteid),
          recipientId: Number(note.partyid),
          email: note.partyemail,
          name: note.partydisplayname,
          invoiceNumber: note.crdrnotenumber,
        }))
      );
    } else {
      showWarningSnackbar('No Debit Notes selected. Please select at least one Debit Note to send the email.');
    }
    setShareOpen(false);
  };

  // Function to explicitly clear email selection
  const clearEmailSelection = () => {
    setEmailSendingSelection([]);
    setIndividualEmailSelection([]);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked && rows.length) {
      const newSelected = rows.map((n) => n.crdrnoteid);
      const newEmailSelection = rows.map((n) => ({
        crdrnoteid: n.crdrnoteid,
        partyid: n.partyid,
        partyemail: n.partyemail,
        consigneename: n.partydisplayname,
        crdrnotenumber: n.crdrnotenumber,
      }));
      setSelected(newSelected);
      setEmailSendingSelection(newEmailSelection);
      return;
    }
    setSelected([]);
    setEmailSendingSelection([]);
  };

  const handleClick = (event, row) => {
    const selectedIndex = selected.findIndex((item) => item === row.crdrnoteid);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, row.crdrnoteid);
      const newEmailSelection = emailSendingSelection.concat({
        crdrnoteid: row.crdrnoteid,
        partyid: row.partyid,
        partyemail: row.partyemail,
        consigneename: row.partydisplayname,
        crdrnotenumber: row.crdrnotenumber,
      });
      setEmailSendingSelection(newEmailSelection);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
      const newEmailSelection = emailSendingSelection.filter((item) => item.crdrnoteid !== row.crdrnoteid);
      setEmailSendingSelection(newEmailSelection);
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
      const newEmailSelection = emailSendingSelection.filter((item) => item.crdrnoteid !== row.crdrnoteid);
      setEmailSendingSelection(newEmailSelection);
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
      const newEmailSelection = emailSendingSelection.filter((item) => item.crdrnoteid !== row.crdrnoteid);
      setEmailSendingSelection(newEmailSelection);
    }

    setSelected(newSelected);
  };
  useEffect(() => {
    if (filterColumns.InvoiceDateFrom && filterColumns.InvoiceDateTo) {
      setStartDate(filterColumns.InvoiceDateFrom);
      setEndDate(filterColumns.InvoiceDateTo);
    } else {
      setStartDate(userPreferece?.financialYear?.startdate);
      setEndDate(userPreferece?.financialYear?.enddate);
    }
  }, [filterColumns, userPreferece]);
  console.log(rows, '****rows');

  const handleChangePage = (event, newPage) => {
    if (circularOpen) return;
    if (newPage > page) {
      if (rows.length !== dataCount)
        if (rows.length < rowsPerPageRef.current * (newPage + 1)) {
          listCreditDebitMaster(false, rows.length, Math.abs(rowsPerPageRef.current * (newPage + 1) - rows.length));
        }
    }

    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    if (circularOpen) return;
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPageRef.current - rows.length) : 0;

  const filterBySearch = (event, category, value) => {
    setPage(0);
    let query = value ? value : event.target?.value;
    let name = category;
    const obj = { ...filterColumnsRef.current };
    if (name != 'GrandTotalAmount') {
      for (const key in obj) {
        if (key == name) {
          obj[key] = query;
        } else {
          // obj[key] = "";
        }
      }
    } else {
      obj['AmountFrom'] = query[0];
      obj['AmountTo'] = query[1];
    }
    setFilterColumns(obj);
  };
  let search = (obj) => {
    listCreditDebitMaster(true, 0, rowsPerPageRef.current, obj);
  };

  if (!debouncedSearchRef.current) {
    debouncedSearchRef.current = createDebouncedCallback(
      (obj) => {
        // Always use current values from refs
        const currentFilterColumns = filterColumnsRef.current;
        const currentRowsPerPage = rowsPerPageRef.current;

        // Check if there are any non-empty filter values
        const hasFilters = Object.values(currentFilterColumns).some((value) => value && value.toString().trim().length > 0);

        if (hasFilters) {
          listCreditDebitMaster(true, 0, currentRowsPerPage, currentFilterColumns);
        } else {
          listCreditDebitMaster(true, 0, currentRowsPerPage);
        }
      },
      500,
      false
    );
  }

  const filterSearch = useCallback((obj) => {
    debouncedSearchRef.current(obj);
  }, []);
  useEffect(() => {
    setFilteredList(rows);
  }, [rows]);
  const [limit, setlimit] = useState(rowsPerPageRef.current);
  const [filterColumnsMaxValues, setfilterColumnsMaxValues] = useState({
    GrandTotalAmount: 0,
  });

  useEffect(() => {
    API.graphql(
      graphqlOperation(listCrDrNoteMasterv2, {
        rowfrom: 0,
        limitno: 1,
        columnname: 'GrandTotalAmount',
        ordertype: 'DESC',
        searchmode: 0,
        searcharray: JSON.stringify([]),
        crdrnotetypecd: 'DebitNote',
      })
    ).then((res) => {
      console.log(res);
      setfilterColumnsMaxValues((prev) => ({ ...prev, GrandTotalAmount: res?.data?.listCrDrNoteMasterv2?.[0]?.grandtotalamount }));
    });
    return () => {};
  }, []);
  // const [dataLoader,setDataLoader] = useState(true)
  async function listCreditDebitMaster(reset, from, to, filterColumn) {
    try {
      setCircularOpen(true);
      if (rows.length / rowsPerPageRef.current == page + 1) {
        setlimit(to);
      } else if (rows.length / rowsPerPageRef.current < 1) {
        setlimit(rowsPerPageRef.current - rows.length);
      }
      setCircularOpen(true);
      if (reset) {
        setRows([]);
        setPage(0);
      }
      let searchMode = 0;
      let SearchArray = [];
      filterColumn = filterColumn ? filterColumn : filterColumnsRef.current;
      switch (ListSelection) {
        case 'Active':
          SearchArray = [...SearchArray];
          break;
        case 'Cancelled':
          SearchArray = [...SearchArray];
          break;
        default:
          break;
      }

      // Handle AmountFrom and AmountTo together to avoid duplicates
      const amountFrom = filterColumn.AmountFrom || '';
      const amountTo = filterColumn.AmountTo || '';

      if (amountFrom || amountTo) {
        searchMode = 1;
        // Ensure From < To before adding to SearchArray
        const lowerAmount = Number(amountFrom < amountTo ? amountFrom : amountTo);
        const higherAmount = Number(amountFrom < amountTo ? amountTo : amountFrom);

        // Add both values with correct order
        SearchArray = [...SearchArray, { AmountFrom: lowerAmount }, { AmountTo: higherAmount }];
      } else if (amountFrom) {
        searchMode = 1;
        SearchArray = [...SearchArray, { AmountFrom: amountFrom }];
      } else if (amountTo) {
        searchMode = 1;
        SearchArray = [...SearchArray, { AmountTo: amountTo }];
      }

      Object.keys(filterColumn).map((key) => {
        if (filterColumn[key]?.toString()?.length > 0) {
          // Skip AmountFrom and AmountTo as they are handled above
          if (key !== 'AmountFrom' && key !== 'AmountTo') {
            searchMode = 1;
            SearchArray = [...SearchArray, { [key]: filterColumn[key] }];
          }
        }
      });

      let res = await Promise.all([
        await API.graphql(
          graphqlOperation(listCrDrNoteMasterv2, {
            rowfrom: from,
            limitno: to,
            columnname: orderBy,
            ordertype: order.toUpperCase(),
            searchmode: searchMode,
            searcharray: JSON.stringify(SearchArray),
            crdrnotetypecd: 'DebitNote',
          })
        ),
        await API.graphql(
          graphqlOperation(listCrDrNoteMasterCount, {
            rowfrom: from,
            limitno: to,
            columnname: orderBy,
            ordertype: order.toUpperCase(),
            searchmode: searchMode,
            searcharray: JSON.stringify(SearchArray),
            crdrnotetypecd: 'DebitNote',
          })
        ),
      ]);

      let count = res?.[1].data;
      let data = res?.[0].data;

      setdataCount(
        count.listCrDrNoteMasterCount[0]?.statuscode == null ? parseInt(count.listCrDrNoteMasterCount[0].crdrnotemasterlistcount) : 0
      );
      let arr = [];
      let arrD = [];
      if (data?.listCrDrNoteMasterv2 != null) {
        arr = data.listCrDrNoteMasterv2.filter((elem) => elem.statuscode == null);
        arr.map((item) => {
          let from = new Date(Number(item.crdrnotedate) * 1000);
          let frommm = from.getMonth() + 1;
          let fromdd = from.getDate();

          if (fromdd < 10) fromdd = '0' + fromdd;
          if (frommm < 10) frommm = '0' + frommm;

          item.customerorsupplierid = {
            PartyID: item.partyid,
            partyAccountID: item.partyaccountid,
          };
          item.customerorsuppliertype = item.partytypecd;
          item.statuscd = item.receivedamount >= item.grandtotalamount ? 'Paid' : item.receivedamount === 0 ? 'Unpaid' : 'Partial';
          item.dueDate = formatUnixTimestamp(item.duedatetimestamp);
          item.balancedueamount = item.grandtotalamount - item.partamount;
          item.invno = [];
        });
      }
      let cArr = [...arr, ...arrD];
      if (reset) {
        setRows((prev) => [...cArr]);
        setFilteredList((prev) => [...cArr]);
        setCircularOpen(false);
      } else {
        setRows((prev) => [...prev, ...cArr]);
        setFilteredList((prev) => [...prev, ...cArr]);
        setCircularOpen(false);
      }
      setlimit(0);
      setCircularOpen(false);
    } catch (error) {
      setlimit(0);
      console.log(error);
    }
  }
  const [firstMount, setfirstMount] = useState({ current: true });
  useEffect(() => {
    if (firstMount.current) {
      setfirstMount({ current: false });
    }
  }, []);

  useEffect(() => {
    if (firstMount.current === false) {
      // Use the debounced search which will check current filterColumns
      filterSearch();
    }
    return () => {};
  }, [filterColumns, filterSearch]);

  useEffect(() => {
    const controlAndS = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === 's') {
        e.preventDefault();
        // showErrorSnackbar("Nothing to save");
      }
    };

    window.addEventListener('keydown', controlAndS);

    return () => {
      window.removeEventListener('keydown', controlAndS);
    };
  }, []);

  useEffect(() => {
    setFilteredList([]);
    setRows([]);
    setPage(0);
    clearEmailSelection();
    setSelected([]);
    listCreditDebitMaster(true, 0, rowsPerPageRef.current);
    return () => {};
  }, [order, orderBy]);

  const [backdropOpen, setBackdropOpen] = useState(false);
  var date = new Date(),
    y = date.getFullYear();
  var firstDay = new Date(y, 0, 1);
  var lastDay = new Date(y, 12, 0);

  const [ledgerModalStartDate, setLedgerModalStartDate] = useState(Math.floor(new Date(firstDay).getTime() / 1000));
  const [ledgerModalEndDate, setLedgerModalEndDate] = useState(Math.floor(new Date(lastDay).getTime() / 1000));

  const [shareOpen, setShareOpen] = useState(false);
  const [accountID, setAccountID] = useState('');

  // Email functionality state
  const [emailSendingSelection, setEmailSendingSelection] = useState([]);
  const [individualEmailSelection, setIndividualEmailSelection] = useState([]);
  const { openModal, modalProps } = useSendEmailModal(['debitNote']);

  useEffect(() => {
    getUserPreferences();
  }, []);
  let userPreference = useSelector((state) => state.userPrefrenceandReducer);

  async function getUserPreferences() {
    try {
      setLedgerModalStartDate(userPreference?.financialYear?.StartDate);
      setLedgerModalEndDate(userPreference?.financialYear?.EndDate);
    } catch (error) {
      setBackdropOpen(false);
      console.log(error);
    }
  }
  let { WarningModal, handleOpen: setWarningOpen } = useWarningModal();

  useEffect(() => {
    if (firstMount.current === false) {
      if (rowsPerPageRef.current > rows.length) {
        listCreditDebitMaster(true, 0, rowsPerPageRef.current);
      } else {
      }
    }
    return () => {};
  }, [rowsPerPage]);

  // Clear email selection when selected array is cleared
  useEffect(() => {
    // Only clear email selection if both selected and emailSendingSelection are empty
    // This prevents clearing email selection when individual Share button is clicked
    if (selected.length === 0 && emailSendingSelection.length === 0) {
      // Both are already empty, no need to do anything
    }
  }, [selected, emailSendingSelection]);

  const [EnableSearch, setEnableSearch] = useState(false);

  const DateRangeRef = useRef(null);
  const containerRef = useRef(null);
  const openDateRange = () => {
    setEnableSearch(true);
    DateRangeRef?.current?.openDatePicker();
  };
  const [SummaryData, setSummaryData] = useState({
    open: false,
    description: '',
    vouchers: [],
  });
  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  const [rolling, setRolling] = useState(false);
  const [showAction, setShowAction] = useState(true);
  const debitTableRef = useRef(null);

  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    if (rows.length > 0 && !circularOpen) {
      const width = debitTableRef.current?.offsetWidth;
      const screenWidth = window.innerWidth;
      if (width < screenWidth - 50) {
        setScroll(false);
      } else {
        setScroll(true);
      }
    }
  }, [rows, circularOpen]);

  return (
    <Box className="noTableCellBorder">
      <DeleteCrDrNoteMaster
        open={deleteModalStatus}
        storage={'purchase&expenses'}
        itemId={deleteId}
        setOpen={setDeleteModalStatus}
        itemData={itemData}
        rows={rows}
        setRows={setRows}
      />
      <DeleteSelectedCrDrNoteMaster
        open={deleteSelectedModal}
        setOpen={setDeleteSelectedModal}
        itemsData={selected}
        rows={rows}
        setSelected={setSelected}
        listCreditDebitMaster={listCreditDebitMaster}
        setRows={setRows}
        setSummaryData={setSummaryData}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderTopRightRadius: '12px',
          borderTopLeftRadius: '12px',
          padding: '8px 10px',
          backgroundColor: 'primary.main',
        }}
      >
        <LinkList list="Debit Note" link="/adddebitnote" add="Add Debit Note" name="debit" />

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <TableSearchButton
            setEnableSearch={setEnableSearch}
            EnableSearch={EnableSearch}
            id={'debitNoteSearch'}
            onClick={handleResetFilterColumns}
          />
          <Box
            sx={{
              display: {
                xs: 'none',
                sm: 'flex',
                md: 'flex',
                lg: 'flex',
                xl: 'flex',
                gap: '10px',
              },
              alignItems: 'center',
            }}
          >
            <Typography sx={{ whiteSpace: 'nowrap', fontSize: '13px', color: 'white' }}>
              Total : {dataCount} Item{dataCount !== 1 && 's'} {selected.length != 0 ? `(Selected: ${selected.length}/${dataCount})` : ''}
            </Typography>

            <DropDownForListing
              name={'ser'}
              value={ListSelection}
              onChange={(e) => {
                let value = e.target.value;
                setListSelection(value);
                setFilterColumns((prev) => ({
                  ...prev,
                  CancelFlag: value != 'All' ? (value == 'Active' ? 0 : 1) : '',
                }));
              }}
            />

            <div className="dropdown-list">
              <SimplePeriodDropdown
                value={{
                  from: filterColumns.CrdrNoteDateFrom || null,
                  to: filterColumns.CrdrNoteDateTo || null,
                }}
                onChange={(range) => {
                  setFilterColumns((prev) => ({
                    ...prev,
                    CrdrNoteDateFrom: range.from || '',
                    CrdrNoteDateTo: range.to || '',
                  }));
                }}
                title=""
                selectedWhenNull="year"
              />
            </div>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                // border: "1px solid #fff",
                borderRadius: '5px',
                p: 1,
                cursor: 'pointer',
                '&:hover': {
                  borderColor: '#ccc',
                  backgroundColor: theme.palette.input.border || '#f5f5f5',
                },
              }}
              onClick={handleClickBox} // Toggle the popover on box click
            >
              <MoreVert sx={{ fontSize: '20px', color: '#fff' }} />

              <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <Box sx={{ p: 1, minWidth: '200px' }}>
                  {options.map((option, index) =>
                    option.rollingOutSoon ? (
                      <Typography
                        key={index}
                        onClick={() => {
                          handleClose();
                        }}
                        sx={{
                          padding: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          // '&:hover': {
                          //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                          // },
                        }}
                      >
                        <Tooltip
                          title={<RollingSoon />}
                          placement="right"
                          PopperProps={{
                            sx: {
                              '& .MuiTooltip-tooltip': {
                                backgroundColor: 'transparent',
                                boxShadow: 'none',
                                padding: 0,
                              },
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            {option.icon}
                            <span style={{ marginLeft: '8px', opacity: 0.5 }}>{option.label}</span>
                          </Box>
                        </Tooltip>
                      </Typography>
                    ) : (
                      <Link style={{ textDecoration: 'none', color: 'inherit' }} to={option.link} state={{ fromLink: '/customerList' }}>
                        <Typography
                          key={index}
                          onClick={() => {
                            handleClose();
                            option.onClick();
                          }}
                          sx={{
                            cursor: 'pointer',
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            // '&:hover': {
                            //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                            // },
                          }}
                        >
                          {option.icon}
                          <span style={{ marginLeft: '8px' }}>{option.label}</span>
                        </Typography>
                      </Link>
                    )
                  )}
                </Box>
              </Popover>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: {
            xs: 'none',
            sm: 'flex',
            md: 'flex',
            lg: 'flex',
            xl: 'flex',
          },
        }}
      >
        <MUILink
          underline="none"
          color="inherit"
          href="/addpurchaseandexpensetaxable"
          // target="_blank"
        ></MUILink>
      </Box>
      <>
        <Box
          sx={{
            // boxShadow: "inset 0 0 8px #d7d7d73b",
            // boxShadow: "rgb(33 35 38 / 10%) 0px 10px 10px -10px",
            boxShadow: 'rgb(33 35 38 / 10%) 0px 10px 10px -10px',
            // boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.5)",
            borderBottomRightRadius: '12px',
            borderBottomLeftRadius: '12px',
            // backgroundColor: theme.palette.bodyGray.secondary,
            // borderRadius:'12px',
            padding: {
              // xs: "8px 12px",
            },
            '.css-1mxz8qt-MuiPaper-root': {
              boxShadow: 'none',
            },
            '.MuiTableCell-root': {
              padding: '1px 10px',
              fontSize: '13px',
            },
            '.MuiTableCell-head': {
              backgroundColor: 'background.tablebg',
              padding: '5px 10px',
              borderBottom: '0px',
            },
          }}
        >
          <Box sx={{ width: '100%', overflow: 'hidden', boxShadow: 'none' }}>
            <TableContainer
              ref={containerRef}
              className="custom-scrollbar"
              sx={{
                height: {
                  sm: 'calc( 100vh - 230px )',
                  xs: 'calc( 100vh - 180px )',
                },
              }}
            >
              <Table
                stickyHeader
                aria-label="sticky table"
                // sx={{ minWidth: 750 }}
                aria-labelledby="tableTitle"
                size={dense ? 'small' : 'medium'}
              >
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={order}
                  setEnableSearch={setEnableSearch}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={dataCount}
                  onDelete={() => setDeleteSelectedModal(true)}
                  rowLength={rows.length}
                  setShowAction={setShowAction}
                  showAction={showAction}
                  scroll={scroll}
                />
                <TableBody ref={debitTableRef}>
                  <TableRow
                    sx={{
                      '.MuiTableCell-root': {
                        backgroundColor: 'transparent ',
                        padding: '8px 15px',
                      },
                      '.css-wrnu0i-MuiInputBase-root': {
                        fontSize: '13px',
                      },
                      '.css-xk0adg-MuiButtonBase-root-MuiIconButton-root': {
                        padding: '2px 4px',
                      },
                      '.css-1gqfvv-MuiPaper-root': {
                        boxShadow: 'none',
                        borderBottom: 'solid 1px rgba(0,0,0,0.24)',
                        borderRadius: '0px',
                      },
                      // visibility: !EnableSearch ? "collapse" : "visible",
                      display: !EnableSearch ? 'none' : 'content',
                    }}
                  >
                    <TableCell></TableCell>
                    <TableCell>
                      <Paper
                        id="debitNoteSearch"
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        {/* <InputBase
                        name="supplierInvoiceDate"
                        value={filterColumns.supplierInvoiceDate}
                        onChange={(e) =>
                          handleFilterBySearch(e, "SupplierInvoiceDate")
                        }
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      /> */}
                        <DateRangeRsuite
                          ref={DateRangeRef}
                          containerRef={containerRef}
                          value={[
                            filterColumns.CrdrNoteDateFrom ? filterColumns.CrdrNoteDateFrom : null,
                            filterColumns.CrdrNoteDateTo ? filterColumns.CrdrNoteDateTo : null,
                          ]}
                          onChange={({ from, to }) => {
                            setFilterColumns((prev) => ({
                              ...prev,
                              CrdrNoteDateFrom: from ? from : '',
                              CrdrNoteDateTo: to ? to : '',
                            }));
                          }}
                          className="hide-input-outline hide-input-border"
                        />
                        {/* <IconButton type="button" sx={{ p: "0px" }}>
                          {filterColumns.CrdrNoteDateFrom !== '' || filterColumns.CrdrNoteDateTo != '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  CrdrNoteDateFrom: '',
                                  CrdrNoteDateTo: '',
                                }));
                                setFilteredList(rows);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton> */}
                      </Paper>
                    </TableCell>
                    {/* <TableCell>
                    <Paper
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <InputBase
                        name="crdrNoteDate"
                        value={filterColumns.crdrNoteDate}
                        onChange={(e) => filterBySearch(e, "CrDrNoteDate")}
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      />
                      <IconButton type="button" sx={{ p: "0px" }}>
                        {filterColumns.crdrNoteDate !== "" ? (
                          <Clear
                            fontSize="small"
                            onClick={() => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                crdrNoteDate: "",
                              }));
                              setFilteredList(rows);
                            }}
                          />
                        ) : (
                          <SearchIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Paper>
                  </TableCell> */}
                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <InputBase
                          name="CrDrNoteNumber"
                          value={filterColumns.CrDrNoteNumber}
                          onChange={(e) => filterBySearch(e, 'CrDrNoteNumber')}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ p: '0px' }}>
                          {filterColumns.CrDrNoteNumber !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  CrDrNoteNumber: '',
                                }));
                                setFilteredList(rows);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>
                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <InputBase
                          name="partyInvoiceNumber"
                          value={filterColumns.PartyInvoiceNumber}
                          onChange={(e) => filterBySearch(e, 'PartyInvoiceNumber')}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ p: '0px' }}>
                          {filterColumns.PartyInvoiceNumber !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  PartyInvoiceNumber: '',
                                }));
                                setFilteredList(rows);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>
                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <InputBase
                          name="partyName"
                          value={filterColumns.PartyName}
                          onChange={(e) => filterBySearch(e, 'PartyName')}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ p: '0px' }}>
                          {filterColumns.PartyName !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  PartyName: '',
                                }));
                                setFilteredList(rows);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>
                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        {/* <InputBase
                        name="Status"
                        value={filterColumns.Status}
                        onChange={(e) => handleFilterBySearch(e, "Status")}
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      /> */}

                        <Autocomplete
                          id={''}
                          disableClearable
                          options={['UNPAID', 'PAID', 'PARTIAL']}
                          isOptionEqualToValue={(option, value) => option == value}
                          clearIcon={filterColumns.Status !== '' ? <ClearIcon style={{ fontSize: '20px' }} /> : null}
                          value={filterColumns.Status}
                          // onChange={onChange}
                          onChange={(e, value) => filterBySearch(e, 'Status', value)}
                          size="small"
                          sx={{ height: '32px' }}
                          renderOption={(props, option) => (
                            <>
                              <MenuItem {...props} key={option} value={option}>
                                <ListItemText primary={option} />
                              </MenuItem>
                            </>
                          )}
                          renderInput={(params) => (
                            <TextField
                              sx={{
                                minWidth: '100px',
                                border: 'none', // Ensure border is removed
                                '& .MuiInput-underline:before': {
                                  borderBottom: 'none', // Remove underline in standard variant
                                },
                                '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                                  borderBottom: 'none', // Remove hover effect
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: 'none', // Remove underline for focused state
                                },
                                '& fieldset': { border: 'none' },
                              }}
                              placeholder={'Search'}
                              variant="standard"
                              InputLabelProps={{
                                shrink: true,
                                style: { color: 'black' },
                              }}
                              // onFocus={(e) => {
                              //   // When the input is focused, change the label to empty
                              //   e.target.placeholder = ""; // Remove placeholder text on focus if needed
                              // }}
                              // onBlur={(e) => {
                              //   // When the input loses focus, revert changes if necessary
                              //   e.target.placeholder = filterColumns.Status
                              //     ? ""
                              //     : "Search"; // Revert placeholder text on blur if needed
                              // }}
                              {...params}
                            />
                          )}
                        />
                        <IconButton type="button" sx={{ p: '0px' }}>
                          {filterColumns.Status !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  Status: '',
                                }));
                                setFilteredList(rows);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>
                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <DateRangeRsuite
                          ref={DateRangeRef}
                          value={[
                            filterColumns.DueDateFrom ? filterColumns.DueDateFrom : null,
                            filterColumns.DueDateTo ? filterColumns.DueDateTo : null,
                          ]}
                          onChange={({ from, to }) => {
                            setFilterColumns((prev) => ({
                              ...prev,
                              DueDateFrom: from ? from : '',
                              DueDateTo: to ? to : '',
                            }));
                          }}
                          className="hide-input-outline hide-input-border"
                        />
                        {/* <IconButton type="button" sx={{ p: '0px' }}>
                          {filterColumns.DueDateFrom !== '' || filterColumns.DueDateTo != '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  DueDateFrom: '',
                                  DueDateTo: '',
                                }));
                                setFilteredList(rows);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton> */}
                      </Paper>
                    </TableCell>
                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <Stack direction={'row'} height={'32px'} gap="5px">
                          <MoneyTextFieldRange
                            value={[filterColumns.AmountFrom, filterColumns.AmountTo]}
                            onChange={(e) => {
                              filterBySearch(e, 'GrandTotalAmount', e);
                            }}
                          />

                          <IconButton type="button" sx={{ p: '0px' }}>
                            {filterColumns.AmountFrom !== '' || filterColumns.AmountTo !== '' ? (
                              <Clear
                                fontSize="small"
                                onClick={() => {
                                  setFilterColumns((prev) => ({
                                    ...prev,
                                    AmountFrom: '',
                                    AmountTo: '',
                                  }));
                                }}
                              />
                            ) : (
                              <SearchIcon fontSize="small" />
                            )}
                          </IconButton>
                        </Stack>
                      </Paper>
                    </TableCell>
                    {/* <TableCell>
                    <Paper
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <InputBase
                        name="balanceDue"
                        value={filterColumns.balanceDueAmount}
                        onChange={(e) => filterBySearch(e, "BalanceDueAmount")}
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      />
                      <IconButton type="button" sx={{ p: "0px" }}>
                        {filterColumns.balanceDueAmount !== "" ? (
                          <Clear
                            fontSize="small"
                            onClick={() => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                balanceDueAmount: "",
                              }));
                              setFilteredList(rows);
                            }}
                          />
                        ) : (
                          <SearchIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Paper>
                  </TableCell> */}
                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <InputBase
                          name="overDueDays"
                          value={filterColumns.overDueDays}
                          onChange={(e) => filterBySearch(e, 'overDueDays')}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ p: '0px' }}>
                          {filterColumns.OverDueDays !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  overDueDays: '',
                                }));
                                setFilteredList(rows);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>
                    <TableCell className="actionBackGround" sx={{ backgroundColor: 'transparent !important' }}></TableCell>

                    {/* <TableCell>
                                    <Paper
                                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%' }}
                                    >
                                        <InputBase
                                        sx={{ flex: 1 }}
                                        placeholder="Search"
                                        />
                                        <IconButton type="button" sx={{ p: '0px' }}>
                                        <SearchIcon fontSize='small' />
                                        </IconButton>
                                    </Paper>
                                </TableCell> */}
                    {/* <TableCell></TableCell> */}
                  </TableRow>
                  {rows.length > 0 ? (
                    rows.slice(page * rowsPerPageRef.current, page * rowsPerPageRef.current + rowsPerPageRef.current).map((row, index) => {
                      const isItemSelected = isSelected(row.crdrnoteid);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      let status = row.statuscd;
                      switch (status) {
                        case 'Paid':
                          status = (
                            <Typography
                              sx={{
                                color: row.cancelflag === 1 ? 'gray' : '#009933',
                                opacity: row.cancelflag === 1 ? 0.5 : 1,
                                fontSize: '13px',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              <CheckCircleIcon
                                sx={{
                                  color: row.cancelflag === 1 ? 'gray' : '#009933',
                                  opacity: row.cancelflag === 1 ? 0.5 : 1,
                                  fontSize: '15px',
                                  marginRight: '5px',
                                }}
                              />{' '}
                              {row.statuscd}
                            </Typography>
                          );
                          break;
                        case 'Unpaid':
                          status = (
                            <Typography
                              sx={{
                                color: row.cancelflag === 1 ? 'gray' : '#eb4141',
                                opacity: row.cancelflag === 1 ? 0.5 : 1,
                                fontSize: '13px',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              <ErrorIcon
                                sx={{
                                  color: row.cancelflag === 1 ? 'gray' : '#eb4141',
                                  opacity: row.cancelflag === 1 ? 0.5 : 1,
                                  fontSize: '15px',
                                  marginRight: '5px',
                                }}
                              />{' '}
                              {row.statuscd}
                            </Typography>
                          );
                          break;
                        case 'Partial':
                          status = (
                            <Typography
                              sx={{
                                color: row.cancelflag === 1 ? 'gray' : '#6096d9',
                                opacity: row.cancelflag === 1 ? 0.5 : 1,
                                fontSize: '13px',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              <RunningWithErrorsIcon
                                sx={{
                                  color: row.cancelflag === 1 ? 'gray' : '#6096d9',
                                  opacity: row.cancelflag === 1 ? 0.5 : 1,
                                  fontSize: '15px',
                                  marginRight: '5px',
                                }}
                              />{' '}
                              {row.statuscd}
                            </Typography>
                          );
                          break;
                        default:
                          break;
                      }
                      let currencySymbol = '₹'; //billingCurrencyOptions.find((elem) => row.CurrencyCode == elem.value)?.sign

                      return (
                        <TableRow
                          sx={{
                            '.MuiTableCell-root': {
                              backgroundColor: 'transparent ',
                              borderBottom: 'none',
                            },
                          }}
                          hover
                          // onClick={(event) => handleClick(event, row.voucherNo)}
                          onClick={(event) => {
                            // dispatch(updateTitle(row.CrDrNoteNumber));
                            // dispatch(
                            //   updateViewTitle(
                            //     row.cancelflag == 1
                            //       ? {
                            //         type: "Cancelled",
                            //         name: row.crdrnotenumber,
                            //       }
                            //       : { type: "", name: row.crdrnotenumber }
                            //   )
                            // );
                            dispatch(updateTitle(row.crdrnotenumber));
                            navigate('/viewdebitnote', {
                              state: {
                                id: row.crdrnoteid,
                                view: true,
                              },
                            });
                          }}
                          className={row.cancelflag === 1 ? 'rowInactiveMuted' : ''}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={index}
                          selected={isItemSelected}
                          style={{ cursor: 'pointer' }}
                        >
                          <TableCell
                            padding="checkbox"
                            sx={{
                              '.css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root': {
                                padding: '5px',
                              },
                            }}
                          >
                            <Checkbox
                              color="primary"
                              onClick={(event) => {
                                event.stopPropagation();
                              }}
                              onChange={(event) => {
                                event.stopPropagation();
                                handleClick(event, row);
                              }}
                              checked={isItemSelected}
                              inputProps={{
                                'aria-labelledby': labelId,
                              }}
                              size="small"
                            />
                          </TableCell>
                          <TableCell
                            // component="th"
                            id={labelId}
                            scope="row"
                            // padding="none"
                            title={row.cancelflag === 1 ? 'Cancelled' : ''}
                          >
                            {formatUnixTimestamp(row.crdrnotedate)}
                          </TableCell>
                          <TableCell title={row.cancelflag === 1 ? 'Cancelled' : ''} align="left">
                            {/* <MUILink
                                underline="hover"
                                sx={{ cursor: "pointer" }}
                              > */}

                            {/* </MUILink> */}
                            <a
                              href={`/viewdebitnote/${row.crdrnotenumber}?transaction=${row.crdrnoteid}`}
                              target="_blank"
                              rel="noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              {row.crdrnotenumber}
                            </a>
                          </TableCell>
                          <TableCell title={row.cancelflag === 1 ? 'Cancelled' : ''} sx={{}} align="left">
                            {/* {clickable == index
                                ? row.InvNo.join(",")
                                : row.InvNo.slice(0, 10).join(",")}

                              {row.InvNo.length > 1 ? (
                                <FormControlLabel
                                  sx={{
                                    ".css-i4bv87-MuiSvgIcon-root ": {
                                      height: "10px",
                                    },
                                    ".css-ahj2mt-MuiTypography-root": {
                                      fontSize: "10px",
                                      color: "input.label",
                                    },
                                  }}
                                  checked={clickable === index ? true : false}
                                  control={<Checkbox />}
                                  label="...Show more items "
                                  size="small"
                                  onChange={(e) => {
                                    e.stopPropagation();
                                    if (clickable === index) {
                                      setClickable(null);
                                    } else {
                                      setClickable(index);
                                    }
                                  }}
                                />
                              ) : (
                                ""
                              )} */}
                            <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {row.partyinvoicenumber?.split(',').map((num, i) => (
                                <React.Fragment key={i}>
                                  <a
                                    className="myLink"
                                    rel="noreferrer"
                                    onClick={(e) => e.stopPropagation()}
                                    href={
                                      row.customerorsuppliertype === 'SUPPLIER'
                                        ? `/viewnewpurchasetax/${num.trim()}?transaction=${row.originalinvoicenumber}`
                                        : `/viewnewinvoicetax/${num.trim()}?transaction=${row.originalinvoicenumber}`
                                    }
                                    target="_blank"
                                  >
                                    {num.trim()}
                                  </a>
                                  {i < row.partyinvoicenumber.split(',').length - 1 && ', '}
                                </React.Fragment>
                              ))}
                            </span>
                            {/* {row.partyinvoicenumber} */}
                          </TableCell>

                          <TableCell
                            align="left"
                            title={row.cancelflag === 1 ? 'Cancelled' : ''}
                            onClick={(e) => {
                              // e.stopPropagation();
                              // navigate(
                              //   row.customerOrSupplierType === "SUPPLIER"
                              //     ? "/viewsupplier"
                              //     : "/viewcustomer",
                              //   {
                              //     state: {
                              //       id: row.PartyID,
                              //       view: true,
                              //     },
                              //   }
                              // );
                            }}
                            sx={{
                              maxWidth: '100px',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {/* <Link
                                underline="hover"
                                style={{
                                  color: theme.palette.text.Link,
                                  cursor: "pointer",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  // navigate(
                                  //   row.customerOrSupplierType === "SUPPLIER"
                                  //     ? "/viewsupplier"
                                  //     : "/viewcustomer",
                                  //   {
                                  //     state: {
                                  //       id: row.PartyID,
                                  //       view: true,
                                  //     },
                                  //   }
                                  // );
                                }}
                              > */}
                            <Tooltip title={row.partydisplayname} placement="right">
                              <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                <a
                                  className="myLink"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                  href={
                                    row.customerorsuppliertype === 'SUPPLIER'
                                      ? `/viewsupplier?id=${row.partyid}&view=true&title=${row.partydisplayname}`
                                      : `/viewcustomer?id=${row.partyid}&view=true&title=${row.partydisplayname}`
                                  }
                                  target="_blank"
                                >
                                  {row.partydisplayname}
                                </a>
                              </span>
                            </Tooltip>
                            {/* </Link> */}
                          </TableCell>
                          <TableCell
                            title={row.cancelflag === 1 ? 'Cancelled' : ''}
                            align="left"
                            sx={{
                              fontSize: '13px',
                              color:
                                row.cancelflag === 1
                                  ? 'gray'
                                  : row.partamount >= row.grandtotalamount
                                  ? '#009933'
                                  : row?.partamount === 0
                                  ? '#eb4141'
                                  : '#6096d9',
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}> {status}</Box>
                          </TableCell>
                          <TableCell title={row.cancelflag === 1 ? 'Cancelled' : ''} align="left" sx={{ whiteSpace: 'nowrap' }}>
                            {row.dueDate}
                          </TableCell>
                          <TableCell title={row.cancelflag === 1 ? 'Cancelled' : ''} align="right">
                            <a
                              underline="hover"
                              style={{
                                color: theme.palette.text.Link,
                                cursor: 'pointer',
                              }}
                              href={`/LedgerTransactions/${row?.partyaccountid}/`}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (row?.partyaccountid !== '') {
                                  // localStorage.removeItem('IsLedgerViewModalOpen')
                                  // setBackdropOpen(true);
                                  // setAccountName(row.partydisplayname);
                                  setAccountID(row.partyaccountid);
                                  // getModalData(row?.PartyAccountID);
                                }
                              }}
                            >
                              {currencySymbol} {MoneyFormatv3(Number(row.grandtotalamount), 'en-IN')}
                            </a>
                          </TableCell>
                          {/* <TableCell align="left">
                            {MoneyFormatv3(Number(row.BalanceDueAmount), "en-IN")}
                          </TableCell> */}
                          <TableCell title={row.cancelflag === 1 ? 'Cancelled' : ''} align="right">
                            <Box>
                              {row.paymentclearedflag === 1 && row.statuscd !== 'Partial' ? (
                                0
                              ) : row.statuscd === 'Paid' ? (
                                '-'
                              ) : (
                                <span
                                  style={{
                                    color: row.cancelflag === 1 ? 'gray' : row.overduedays < 0 ? 'red' : 'green',
                                    opacity: row.cancelflag === 1 ? 0.5 : 1,
                                  }}
                                >
                                  {Math.abs(row.overduedays)}&nbsp;
                                  {row.statuscd === 'Paid' ? '' : Math.abs(row.overduedays) == 1 ? 'day' : 'days'}
                                </span>
                              )}
                            </Box>
                          </TableCell>

                          <TableCell className="actionBackGround" align="center" sx={{ position: !showAction ? 'relative' : 'sticky' }}>
                            <Box className="actionCellStyle">
                              <Tooltip title={'Download PDF'} placement="left" disableInteractive arrow>
                                <IconButton
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    checkandopenpdf(row.crdrnotepdf);
                                  }}
                                  aria-label="delete"
                                  sx={{
                                    margin: '0px 2px',
                                    padding: '5px',
                                    backgroundColor: '#c5d6dc',
                                    border: 'solid 1px black',
                                  }}
                                >
                                  <img src={pdfImage} height={10} alt="Download" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={'Print'} placement="top" disableInteractive arrow>
                                <IconButton
                                  disableRipple
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    fetchAndPrintPDF(row.crdrnotepdf);
                                  }}
                                  aria-label="delete"
                                  sx={{
                                    margin: '0px 2px',
                                    padding: '5px',
                                    backgroundColor: '#c5d6dc',
                                    border: 'solid 1px black',
                                  }}
                                >
                                  <LocalPrintshop
                                    sx={{
                                      fontSize: '10px',
                                      color: '#36454f',
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                              {/* {row.cancelflag !== 1 && ( */}
                              <Tooltip title={row.cancelflag === 1 ? 'cannot Edit' : 'Edit'} placement="left" disableInteractive arrow>
                                <IconButton
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    if (Freeze == 1) {
                                      return handleFreeze();
                                    }
                                    if (row.cancelflag === 1) {
                                      return;
                                    }
                                    dispatch(updateTitle(row.crdrnotenumber));
                                    navigate('/editdebitnote', {
                                      state: {
                                        id: row.crdrnoteid,
                                        pdflink: row.crdrnotepdf,
                                      },
                                    });
                                  }}
                                  aria-label="delete"
                                  sx={{
                                    margin: '0px 2px',
                                    padding: '5px',
                                    backgroundColor: '#D0EFFF',
                                    border: 'solid 1px black',
                                  }}
                                >
                                  {row.cancelflag === 1 ? (
                                    <EditOff sx={{ fontSize: '10px', color: '#6096d9' }} />
                                  ) : (
                                    <EditIcon
                                      sx={{
                                        fontSize: '10px',
                                        color: '#6096d9',
                                      }}
                                    />
                                  )}
                                </IconButton>
                              </Tooltip>
                              {/* )} */}
                              <Tooltip title={'Share'} placement="left" disableInteractive arrow>
                                <IconButton
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    // For individual Share, use separate state
                                    // that doesn't interfere with bulk selection
                                    setIndividualEmailSelection([
                                      {
                                        crdrnoteid: row.crdrnoteid,
                                        partyid: row.partyid,
                                        partyemail: row.partyemail,
                                        consigneename: row.partydisplayname,
                                        crdrnotenumber: row.crdrnotenumber,
                                      },
                                    ]);
                                    setShareOpen(row.crdrnotepdf);
                                  }}
                                  aria-label="delete"
                                  sx={{
                                    margin: '0px 2px',
                                    padding: '5px',
                                    backgroundColor: '#E8F5E9',
                                    border: 'solid 1px black',
                                    // backgroundColor: '#b1d1f97d'
                                  }}
                                >
                                  <Share
                                    sx={{
                                      fontSize: '10px',
                                      color: '#388E3C',
                                      // color: '#6096d9'
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                              {/* {row.CancelFlag !== 1 && (
                                  <Tooltip
                                    title={"cancel"}
                                    placement="bottom-end"
                                    disableInteractive
                                    arrow
                                  >
                                    <IconButton
                                      sx={{
                                        margin: "0px 2px",
                                        padding: "5px",
                                        backgroundColor: "#b1d1f97d",
                                      }}
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        setWarningOpen({
                                          render: (
                                            <Box>
                                              <Typography>
                                                Are you sure you want to cancel
                                                this Debit Note ?
                                              </Typography>
                                              <Typography
                                                component={"p"}
                                                sx={{ fontSize: "smaller" }}
                                              >
                                                <br />
                                                <b>NOTE : All the payments linked with this debit note will be cancelled immediately.<br />You can't undo
                                                  this action.</b>
                                              </Typography>
                                              <Box sx={{ marginTop: "8px" }}>
                                                <TeaxtareaField
                                                  name="reason"
                                                  placeholder="Reason for Cancellation"
                                                  size="small"
                                                  fullWidth
                                                  rows={6}
                                                  state={state}
                                                  // value={state.reason}
                                                  onChange={(e) => {
                                                    if (
                                                      e.target.value.length >
                                                      250
                                                    ) {
                                                      setState((prev) => ({
                                                        ...prev,
                                                        ["reason"]:
                                                          e.target.value,
                                                        ["errorStatus"]: {
                                                          ...prev.errorStatus,
                                                          ["reason"]: true,
                                                        },
                                                        ["errorFields"]: {
                                                          ...prev.errorFields,
                                                          ["reason"]:
                                                            "Reason for Cancellation must be less than 250 characters",
                                                        },
                                                      }));
                                                    } else if (
                                                      e.target.value.length <= 0
                                                    ) {
                                                      setState((prev) => ({
                                                        ...prev,
                                                        ["reason"]:
                                                          e.target.value,
                                                        ["errorStatus"]: {
                                                          ...prev.errorStatus,
                                                          ["reason"]: true,
                                                        },
                                                        ["errorFields"]: {
                                                          ...prev.errorFields,
                                                          ["reason"]:
                                                            "Reason for Cancellation is Required",
                                                        },
                                                      }));
                                                    } else {
                                                      setState((prev) => ({
                                                        ...prev,
                                                        reason: e.target.value,
                                                        ["errorStatus"]: {
                                                          ...prev.errorStatus,
                                                          ["reason"]: false,
                                                        },
                                                        ["errorFields"]: {
                                                          ...prev.errorFields,
                                                          ["reason"]: "",
                                                        },
                                                      }));
                                                    }
                                                  }}
                                                />
                                              </Box>
                                            </Box>
                                          ),
                                          onContinue: async () => {
                                            await cancel(row.CrDrNoteID);
                                          },
                                          onCancel: () => { },
                                        });
                                      }}
                                    >
                                      <Close
                                        sx={{ fontSize: "15px", color: "#6096d9" }}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                )} */}
                              {/* <ThreeDot
                                  onEdit={
                                    row.ExpiredTimeStamp != 0 ||
                                      row.CancelFlag == 1
                                      ? null
                                      : (event) => {
                                        event.stopPropagation();
                                        dispatch(
                                          updateTitle(row.CrDrNoteNumber)
                                        );
                                        navigate("/editdebitnote", {
                                          state: { id: row.CrDrNoteID },
                                        });
                                      }
                                  }
                                  onDelete={
                                    row.ExpiredTimeStamp === 0
                                      ? (event) => {
                                        event.stopPropagation();
                                        setDeleteModalStatus(true);
                                        setItemData({
                                          id: row.CrDrNoteID,
                                          ind: index,
                                        });
                                      }
                                      : null
                                  }
                                  onView={(event) => {
                                    event.stopPropagation();
                                    dispatch(updateTitle(row.CrDrNoteNumber));
                                    navigate("/viewdebitnote", {
                                      state: {
                                        id: row.CrDrNoteID,
                                        view: true,
                                      },
                                    });
                                  }}
                                  onCancel={
                                    row.CancelFlag != 1 &&
                                      row.ExpiredTimeStamp === 0
                                      ? (event) => {
                                        event.stopPropagation();
                                        setWarningOpen({
                                          render: (
                                            <Box>
                                              <Typography>
                                                Are you sure you want to cancel
                                                this Debit Note ?
                                              </Typography>
                                              <Typography
                                                component={"p"}
                                                sx={{ fontSize: "smaller" }}
                                              >
                                                <br />
                                                <b>NOTE : All the payments linked with this debit note will be cancelled immediately.<br />You can't undo
                                                  this action.</b>
                                              </Typography>
                                              <Box sx={{ marginTop: "8px" }}>
                                                <TeaxtareaField
                                                  name="reason"
                                                  placeholder="Reason for Cancellation"
                                                  size="small"
                                                  fullWidth
                                                  rows={6}
                                                  state={state}
                                                  // value={state.reason}
                                                  onChange={(e) => {
                                                    if (
                                                      e.target.value.length >
                                                      250
                                                    ) {
                                                      setState((prev) => ({
                                                        ...prev,
                                                        ["reason"]:
                                                          e.target.value,
                                                        ["errorStatus"]: {
                                                          ...prev.errorStatus,
                                                          ["reason"]: true,
                                                        },
                                                        ["errorFields"]: {
                                                          ...prev.errorFields,
                                                          ["reason"]:
                                                            "Reason for Cancellation must be less than 250 characters",
                                                        },
                                                      }));
                                                    } else if (
                                                      e.target.value.length <= 0
                                                    ) {
                                                      setState((prev) => ({
                                                        ...prev,
                                                        ["reason"]:
                                                          e.target.value,
                                                        ["errorStatus"]: {
                                                          ...prev.errorStatus,
                                                          ["reason"]: true,
                                                        },
                                                        ["errorFields"]: {
                                                          ...prev.errorFields,
                                                          ["reason"]:
                                                            "Reason for Cancellation is Required",
                                                        },
                                                      }));
                                                    } else {
                                                
                                                      setState((prev) => ({
                                                        ...prev,
                                                        reason: e.target.value,
                                                        ["errorStatus"]: {
                                                          ...prev.errorStatus,
                                                          ["reason"]: false,
                                                        },
                                                        ["errorFields"]: {
                                                          ...prev.errorFields,
                                                          ["reason"]: "",
                                                        },
                                                      }));
                                                    }
                                                  }}
                                                />
                                              </Box>
                                            </Box>
                                          ),
                                          onContinue: async () => {
                                            await cancel(row.CrDrNoteID);
                                          },
                                          onCancel: () => { },
                                        });
                                      }
                                      : ""
                                  }
                                /> */}
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : circularOpen == false && rows.length <= 0 && !dataCount > 0 ? (
                    <TableRow>
                      <TableCell height={400} align="center" colSpan={11}>
                        No Data Found
                      </TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}
                  {circularOpen == true &&
                    limit > 0 &&
                    Array.from({ length: limit }, (_, index) => (
                      <TableRow key={index}>
                        <TableCell colSpan={12}>
                          <Skeleton variant="text" sx={{ fontSize: '2rem' }} />
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            {dataCount > 0 && (
              <TablePagination
                sx={{
                  scrollbarWidth: 'thin',
                  '&::-webkit-scrollbar': {
                    // width: '0.4em',
                    height: '0.4em',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: `${theme.palette.primary.main}47`,
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'primary.main',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: `${theme.palette.primary.main}47`,
                  },
                }}
                // rowsPerPageOptions={[5, 10, 25,{ label: 'All', value: -1 }]}
                rowsPerPageOptions={defaultRowsPerPageOptions}
                component="div"
                count={dataCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </Box>

          {shareOpen ? (
            <ShareModal
              open={shareOpen}
              setOpen={setShareOpen}
              text={'Debit'}
              emailData={{
                selectedRow: individualEmailSelection?.map((note) => ({
                  id: Number(note.crdrnoteid),
                  recipientId: Number(note.partyid),
                  email: note.partyemail,
                  name: note.partydisplayname,
                  invoiceNumber: note.crdrnotenumber,
                })),
                type: 'debitNote',
              }}
            />
          ) : null}
          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </Box>
      </>
      {/* <ExportData
        setOpen={setExportModalOpen}
        open={exportModalOpen}
        item={exportItem}
      /> */}
      {WarningModal}
      {accountID && <LedgerTransactionModalv2 open={accountID} accountId={accountID} onClose={() => setAccountID('')} />}
      <SendEmailModalWrapper {...modalProps} />
    </Box>
  );
}

export default AllDebitNote;
